import { required, numeric } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';

function isPowerOfTwo(n) {
    if (n == 0)
        return false;

    return parseInt((Math.ceil((Math.log(n) / Math.log(2)))))
        == parseInt((Math.floor(((Math.log(n) / Math.log(2))))));
}

function is_ipv4_addr(addr)
{
    const regex = new RegExp(/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/);
    return regex.test(addr);
}

function is_ipv4_prefix(addr)
{
    const regex = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}\/(\d{1,2})$/;
    const m = addr.match(regex);
    if (m == null)
        return false;
    const mask = m[4];
    if (mask >= 0 && mask <= 32)
        return true;

    return false;
}

function is_ipv6_addr(addr)
{
    const regex = new RegExp(/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/);
    return regex.test(addr);
}

function is_ipv6_prefix(addr)
{
    const regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(\d{1,3})$/;
    const m = addr.match(regex);
    if (m == null)
        return false;
    const mask = m[31];
    if (mask >= 0 && mask <= 128)
        return true;

    return false;
}

extend('powerof2', {
    ...numeric,
    message: 'This field must be power of two',
    validate: value => (isPowerOfTwo(value))
  });

extend('numeric', {
    ...numeric,
    message: 'This field must be numeric'
  });

extend('ipv4_addr_optional', {
    message: 'Incorrect ipv4 address.',
    validate: value => (value === '' || is_ipv4_addr(value))
});

extend('ipv4_addr', {
    message: 'Incorrect ipv4 address.',
    validate: value => (is_ipv4_addr(value))
});

extend('ipv4_mask', {
    message: 'Incorrect ipv4 mask. Valid range is 0 - 32.',
    validate: value => (value >= 0 && value <= 32)
});

extend('ipv4_prefix', {
    message: 'Incorrect ipv4 prefix.',
    validate: value => (is_ipv4_prefix(value))
});

extend('ipv6_addr_optional', {
    message: 'Incorrect ipv6 address.',
    validate: value => (value === '' || is_ipv6_addr(value))
});

extend('ipv6_addr', {
    message: 'Incorrect ipv6 address.',
    validate: value => (is_ipv6_addr(value))
});

extend('ipv6_mask', {
    message: 'Incorrect ipv6 mask. Valid range is 0 - 128.',
    validate: value => (value >= 0 && value <= 128)
});

extend('ipv6_prefix', {
    message: 'Incorrect ipv6 prefix.',
    validate: value => (is_ipv6_prefix(value))
});

extend('rt_name', {
    message: 'Incorrect route table name.',
    validate: value => (value.length >= 1 && value.length <= 64)
});

extend('required', {
    ...required,
    message: 'This field is required'
});
